/* nur.marketing 2026-09 | Google-Bewertungen Karussell (Pfeile, Punkte, Mehr lesen). Vanilla, defer. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.getAttribute('data-pk-init') === '1') return;
    root.setAttribute('data-pk-init', '1');
    root.classList.add('is-ready');

    // Mehr lesen / Weniger anzeigen
    var mores = root.querySelectorAll('.pk-rev__more');
    for (var m = 0; m < mores.length; m++) {
      mores[m].addEventListener('click', function () {
        var card = this.closest('.pk-rev');
        if (!card) return;
        var open = card.classList.toggle('is-expanded');
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var track = root.querySelector('.pk-reviews__track');
    if (!track) return;
    var cards = track.children;
    if (!cards.length) return;
    var prev = root.querySelector('.pk-reviews__arrow--prev');
    var next = root.querySelector('.pk-reviews__arrow--next');
    var dotsWrap = root.querySelector('.pk-reviews__dots');
    var dots = [];

    function gap() {
      var cs = window.getComputedStyle(track);
      return parseFloat(cs.columnGap || cs.gap) || 0;
    }
    function step() { return cards[0].getBoundingClientRect().width + gap(); }
    function perView() { return Math.max(1, Math.round((track.clientWidth + gap()) / step())); }
    function pages() { return Math.max(1, Math.ceil(cards.length / perView())); }
    function current() { return Math.min(pages() - 1, Math.round(track.scrollLeft / (step() * perView()))); }
    function goTo(p) {
      var n = pages();
      p = Math.max(0, Math.min(n - 1, p));
      var left = p * perView() * step();
      if (reduce || !track.scrollTo) { track.scrollLeft = left; } else { track.scrollTo({ left: left, behavior: 'smooth' }); }
    }

    function buildDots() {
      if (!dotsWrap) return;
      var n = pages();
      if (dots.length === n) return;
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pk-reviews__dot';
        b.setAttribute('aria-label', 'Bewertungen ' + (i + 1) + ' von ' + n);
        (function (idx) { b.addEventListener('click', function () { goTo(idx); }); })(i);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }

    function update() {
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      var n = pages();
      var cur = current();
      buildDots();
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === cur);
        dots[i].setAttribute('aria-current', i === cur ? 'true' : 'false');
      }
      if (prev) { prev.hidden = !scrollable; prev.disabled = cur <= 0; }
      if (next) { next.hidden = !scrollable; next.disabled = cur >= n - 1; }
      if (dotsWrap) dotsWrap.hidden = !scrollable || n < 2;
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; update(); });
    });
    update();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-section-type="pk-google-reviews"]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-section-type="pk-google-reviews"]') : null;
    if (r) init(r);
  });
})();
